export const PASSWORD_LENGTH = Object.freeze({ min: 6, max: 32 });

export const PASSWORD_RULE_MESSAGE = `Password must be between ${PASSWORD_LENGTH.min} and ${PASSWORD_LENGTH.max} characters`;

const CONTROL_CHARACTER = /\p{Cc}/u;

export const normalizePassword = (value) =>
  typeof value === "string" ? value.trim() : "";

export const passwordLength = (value) => [...value].length;

const isWithinLength = (value) =>
  passwordLength(value) >= PASSWORD_LENGTH.min &&
  passwordLength(value) <= PASSWORD_LENGTH.max;

export const isPassword = (value) =>
  typeof value === "string" &&
  value === value.trim() &&
  !CONTROL_CHARACTER.test(value) &&
  isWithinLength(value);
